<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row management-tabs full-height-tabs items-align-management-tabs text-align-management-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('invoice.invoices')" class="text-left">
              <invoice-dashboard v-if="isDashboard"></invoice-dashboard>
            </v-tab>
            <v-tab :title="$t('invoice.proforma')" class="text-left">
              <proforma v-if="isProforma"></proforma>
            </v-tab>
            <v-tab :title="$t('invoice.reports')" class="text-left">
              <invoice-reports v-if="isReports"></invoice-reports>
            </v-tab>
            <v-tab :title="$t('invoice.settings')" class="text-left">
              <invoice-settings v-if="isSettings"></invoice-settings>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

<script>
  import InvoiceDashboard from '../Invoice/InvoiceDashboard.vue'
  import Proforma from '../Invoice/Proforma/Proforma.vue'
  import InvoiceReports from '../Invoice/InvoiceReports.vue'
  import InvoiceSettings from '../Invoice/InvoiceSettings.vue'

  export default {
    components: {
      InvoiceDashboard,
      Proforma,
      InvoiceReports,
      InvoiceSettings
    },
    data () {
      return {
        isDashboard: false,
        isProforma: false,
        isReports: false,
        isSettings: false
      }
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isProforma = false
        this.isDashboard = false
        this.isReports = false
        this.isSettings = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('invoice.invoices'):
            this.isDashboard = true
            break
          case this.$t('invoice.reports'):
            this.isReports = true
            break
          case this.$t('invoice.settings'):
            this.isSettings = true
            break
          case this.$t('invoice.proforma'):
            this.isProforma = true
            break
          default:
            this.isDashboard = true
            break
        }
      }
    }
  }
  </script>

  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Invoice/InvoiceSidebar.vue